import { createFileRoute } from '@tanstack/react-router'
import { ChangelogPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/changelog/')({
  loader: () => loadPageData({ data: { kind: 'changelog', locale: 'de' } }),
  head: () => staticRouteHead('changelog', 'de'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <ChangelogPage />
    </CatalogProvider>
  )
}
